import { cloneDeep } from 'lodash';
import { GraphQLField } from 'graphql';
import { FieldComponentParams } from '@/types/FieldComponent';
import TextFieldFactory from './TextFieldFactory';
import TypeInspector from '../graphql-introspection/TypeInspector';

export default class NumberFieldFactory extends TextFieldFactory {
  support(field: GraphQLField<any, any, any>): boolean {
    const { type } = field;

    return TypeInspector.isScalarType(type) && TypeInspector.isFloat(type);
  }

  createComponent(params: FieldComponentParams) {
    const clonedParams = cloneDeep(params);
    clonedParams.props = {
      ...clonedParams.props,
      type: 'number',
    };
    return super.createComponent(clonedParams);
  }
}
